import { render, staticRenderFns } from "./ExportadorTabela.vue?vue&type=template&id=d340b6ba&scoped=true"
import script from "./ExportadorTabela.vue?vue&type=script&lang=js"
export * from "./ExportadorTabela.vue?vue&type=script&lang=js"
import style0 from "./ExportadorTabela.vue?vue&type=style&index=0&id=d340b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d340b6ba",
  null
  
)

export default component.exports